module.exports = __webpack_public_path__ + "static/img/p3.07d3095.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/p3.png
// module id = 5MiT
// module chunks = 1